/** Druh dokumentu — určuje ikonu (Google Docs / Google Sheets). */
type Druh = 'docs' | 'sheets';

type Formular = { nazev: string; url: string; druh: Druh };

/**
 * Formuláře dílny — odkazy na sdílené Google Docs / Sheets. Seznam je pevně
 * v kódu (mění se zřídka), nový formulář = nový řádek tady.
 */
const FORMULARE: Formular[] = [
  {
    nazev: 'Střihárna - výkaz práce',
    url: 'https://docs.google.com/document/d/1Bkm4rmE1ZcyFknhhBUXRJs6Ws--eNt_x/edit?usp=sharing&ouid=107051584571603382561&rtpof=true&sd=true',
    druh: 'docs',
  },
  {
    nazev: 'Docházka',
    url: 'https://docs.google.com/document/d/1JtNPCXuL186OQdqVz2DqKxOgOIB6tzAq/edit?pli=1',
    druh: 'docs',
  },
];

/** Oficiální barvy ikon Google Docs (modrá) a Google Sheets (zelená). */
function GoogleIcon({ druh }: { druh: Druh }) {
  const fill = druh === 'docs' ? '#4285F4' : '#0F9D58';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 64"
      width="30"
      height="40"
      aria-hidden="true"
      className="shrink-0"
    >
      <path d="M30 0H4a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V18L30 0z" fill={fill} />
      <path d="M30 0v14a4 4 0 0 0 4 4h14L30 0z" fill="#fff" fillOpacity="0.35" />
      {druh === 'docs' ? (
        <path d="M12 30h24v3H12zM12 37h24v3H12zM12 44h24v3H12zM12 51h16v3H12z" fill="#fff" />
      ) : (
        <path
          d="M12 30h24v24H12V30zm3 3v4h7v-4h-7zm10 0v4h8v-4h-8zm-10 7v4h7v-4h-7zm10 0v4h8v-4h-8zm-10 7v4h7v-4h-7zm10 0v4h8v-4h-8z"
          fill="#fff"
        />
      )}
    </svg>
  );
}

export function FormularePage() {
  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-text">Formuláře</h1>
        <p className="text-sm text-text-secondary mt-0.5">
          Sdílené dokumenty a tabulky dílny. Otevřou se v Googlu na nové kartě.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl">
        {FORMULARE.map((f) => (
          <a
            key={f.url}
            href={f.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-surface rounded-xl shadow-card px-5 py-4 border border-border hover:shadow-card-hover hover:border-primary transition-all"
          >
            <GoogleIcon druh={f.druh} />
            <div className="min-w-0">
              <div className="font-semibold text-text">{f.nazev}</div>
              <div className="text-xs text-text-muted">
                {f.druh === 'docs' ? 'Google Docs' : 'Google Sheets'}
              </div>
            </div>
          </a>
        ))}
      </div>
    </>
  );
}
